// Top: Pickup slider initialization (Swiper v8)
// - Works when .pickup-swiper exists on the page (front page)
// - Safe if not present (no-op)
// - Supports multiple instances
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var containers = document.querySelectorAll(".pickup-swiper");
    if (!containers.length) return;

    // Swiper is loaded via WP enqueue and available globally
    if (typeof window.Swiper === "undefined") {
      // Defensive: if somehow Swiper isn't ready, retry once after load
      window.addEventListener(
        "load",
        function () {
          initAll();
        },
        { once: true }
      );
      return;
    }

    initAll();

    function initAll() {
      containers.forEach(function (el) {
        var paginationEl = el.querySelector(".swiper-pagination");
        // Guard: if markup missing, create pagination element
        if (!paginationEl) {
          paginationEl = document.createElement("div");
          paginationEl.className = "swiper-pagination";
          el.appendChild(paginationEl);
        }

        // eslint-disable-next-line no-new
        new Swiper(el, {
          loop: true,
          speed: 1500,
          watchOverflow: true, // disable when not enough slides
          centeredSlides: true,
          spaceBetween: 16,
          slidesPerView: 1.88,
          // Responsive breakpoints
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          // Accessibility baseline
          a11y: {
            enabled: true,
          },
        });
      });
    }
  });
})();
